import React, { ReactElement, ForwardedRef } from 'react';
import TableBodyInternal from '@mui/material/TableBody';
import FormatService from '../../services/format-service';
import useStylesTableBody from './table-body.styles';

const TableBody: ReactMemoComponent = React.memo(React.forwardRef((
  props: ReactComponentProps,
  ref: ForwardedRef<HTMLTableSectionElement>,
): ReactElement => {
  const {
    isPlain,
    isHidden,
    withZebraRows,
    withNoBorders,
    withNoLastBorder,
    withAllBorderCells,
    withTwoColumns,
    withTwoEqualColumns,
    withHeaderColumn,
    withFixedCellsSize,
    withFixedCellsSizeExtended,
    withFixedCellsSizeCompressed,
    withSmallPadding,
    withBorderedCells,
    withBorderedRows,
    withTopAlign,
    withTopBorder,
    withBlockCells,
    className,
    children,
  } = props;

  const { classes } = useStylesTableBody();

  const plainClassName: string | undefined = isPlain ? classes.tableBodyPlain : undefined;
  const noBordersClassName: string | undefined = withNoBorders ? classes.tableBodyNoBorders : undefined;
  const noLastBorderClassName: string | undefined = withNoLastBorder ? classes.tableBodyNoLastBorder : undefined;
  const hiddenClassName: string | undefined = isHidden ? classes.tableBodyHidden : undefined;
  const zebraRowsClassName: string | undefined = withZebraRows ? classes.tableBodyZebraRows : undefined;
  const headerColumnClassName: string | undefined = withHeaderColumn ? classes.tableBodyHeaderColumn : undefined;
  const borderedCellsClassName: string | undefined = withBorderedCells ? classes.tableBodyBorderedCells : undefined;
  const allBorderedCellsClassName: string | undefined = withAllBorderCells
    ? classes.tableBodyAllBorderedCells : undefined;
  const borderedRowsClassName: string | undefined = withBorderedRows ? classes.tableBodyBorderedRows : undefined;
  const smallPaddingClassName: string | undefined = withSmallPadding ? classes.tableBodySmallPadding : undefined;
  const twoColumnsClassName: string | undefined = withTwoColumns ? classes.tableBodyTwoColumns : undefined;
  const twoEqualColumnsClassName: string | undefined = withTwoEqualColumns
    ? classes.tableBodyTwoEqualColumns : undefined;
  const fixedCellsSizeClassName: string | undefined = withFixedCellsSize ? classes.tableBodyFixedCellsSize : undefined;
  const fixedCellsSizeExtendedClassName: string | undefined = withFixedCellsSizeExtended
    ? classes.tableBodyFixedCellsSizeExtended : undefined;
  const fixedCellsSizeCompressedClassName: string | undefined = withFixedCellsSizeCompressed
    ? classes.tableBodyFixedCellsSizeCompressed : undefined;
  const topBorderClassName: string | undefined = withTopBorder ? classes.tableBodyTopBorder : undefined;
  const topAlignClassName: string | undefined = withTopAlign ? classes.tableBodyTopAlign : undefined;
  const blockCellsClassName: string | undefined = withBlockCells ? classes.tableBodyBlockCells : undefined;

  return (
    <TableBodyInternal
      ref={ref}
      className={FormatService.formatClassNames(
        plainClassName, noBordersClassName, noLastBorderClassName, hiddenClassName, zebraRowsClassName,
        headerColumnClassName, allBorderedCellsClassName, borderedCellsClassName, borderedRowsClassName,
        smallPaddingClassName, twoColumnsClassName, twoEqualColumnsClassName, fixedCellsSizeClassName,
        fixedCellsSizeExtendedClassName, fixedCellsSizeCompressedClassName, topAlignClassName, topBorderClassName,
        blockCellsClassName, className,
      )}
    >
      {children}
    </TableBodyInternal>
  );
}));

export default TableBody;
